import React from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';
import DescriptionStylable from '../../../../text/DescriptionStylable';
import { useStatsig } from '../../../../hooks/useStatsig';
import { ClubSubtypes } from '../../../../../utils/constants';

import styles from '../../../../../pages/ClubProfiles/club.scss';

const RosterTabTitleLayout = (props) => {
    const {
        schoolDetails,
        clubDetails,
        isAdminOrOwner,
        userIsPowered,
        isSchool,
        rosterTabState,
        updateRosterTabState,
        history,
        location,
        power6Data,
    } = props;

    const { checkGate, featureGates } = useStatsig();
    const isRostersRolloutEnabled = checkGate(featureGates.ROSTERS_ROLLOUT);

    const {
        tierType,
        id,
        clubSubType,
    } = clubDetails;

    const clubSubTypeId = clubSubType ? clubSubType.id : 0;

    const descriptionItems = [
        ...(schoolDetails.rosterCount ? [{ left: `${schoolDetails.rosterCount}`, right: `${schoolDetails.rosterCount === 1 ? ' Player' : ' Players'}` }] : []),
    ];

    // Use feature flag to determine which Power 6 data to show
    if (isRostersRolloutEnabled) {
        // When feature flag is ON, show Power 6 from rosters-api
        if (power6Data !== null && power6Data !== undefined) {
            if (power6Data.power6Rating) {
                const power6Formatted = power6Data.power6Rating.toFixed(2);
                descriptionItems.push({ left: power6Formatted, right: ` Power 6` });
            }
            if (power6Data.power6HighRating && power6Data.power6LowRating) {
                const power6LowFormatted = power6Data.power6LowRating.toFixed(2);
                const power6HighFormatted = power6Data.power6HighRating.toFixed(2);
                descriptionItems.push({ left: `${power6LowFormatted} - ${power6HighFormatted}`, right: ` Power 6 Spread` });
            }
        }
    }
    // When feature flag is OFF, show existing behavior (gender-specific with spreads)
    if (!isRostersRolloutEnabled && (clubSubTypeId === ClubSubtypes.MENS || clubSubTypeId === ClubSubtypes.WOMENS)) {
        if (schoolDetails.power6) {
            const power6Formatted = schoolDetails.power6.toFixed(2);
            descriptionItems.push({ left: power6Formatted, right: ` Power 6` });
        }
        if (schoolDetails.power6HighRating && schoolDetails.power6LowRating) {
            const power6LowFormatted = schoolDetails.power6LowRating.toFixed(2);
            const power6HighFormatted = schoolDetails.power6HighRating.toFixed(2);
            descriptionItems.push({ left: `${power6LowFormatted} - ${power6HighFormatted}`, right: ` Power 6 Spread` });
        }
    }
    if (!isRostersRolloutEnabled && clubSubTypeId === ClubSubtypes.COED && tierType?.isHighSchool) {
        if (schoolDetails.power6Men) {
            descriptionItems.push({ left: `${schoolDetails.power6Men}`, right: ` Power 6 Boys` });
        }
        if (schoolDetails.power6MenHigh && schoolDetails.power6MenLow) {
            const power6MenLowFormatted = schoolDetails.power6MenLow.toFixed(2);
            const power6MenHighFormatted = schoolDetails.power6MenHigh.toFixed(2);
            descriptionItems.push({ left: `${power6MenLowFormatted} - ${power6MenHighFormatted}`, right: ` Boys Power 6 Spread` });
        }
        if (schoolDetails.power6Women) {
            descriptionItems.push({ left: `${schoolDetails.power6Women}`, right: ` Power 6 Girls` });
        }
        if (schoolDetails.power6WomenHigh && schoolDetails.power6WomenLow) {
            const power6WomenLowFormatted = schoolDetails.power6WomenLow.toFixed(2);
            const power6WomenHighFormatted = schoolDetails.power6WomenHigh.toFixed(2);
            descriptionItems.push({ left: `${power6WomenLowFormatted} - ${power6WomenHighFormatted}`, right: ` Girls Power 6 Spread` });
        }
    }

    return (
        <div className={`bb`}>
            <h6
                className={`${styles.titleContainer}`}
            >
                {`${schoolDetails.rosterYear} Roster`}
                <span className={`${styles.subTitle} mt8 d-block`}>
                    <DescriptionStylable
                        desc={descriptionItems}
                        leftClassName={`text-bold`}
                        noellipsis={true}
                    />
                    {(userIsPowered || isAdminOrOwner) && isSchool && (
                        <React.Fragment>
                            <span>{` \u2022 `}</span>
                            <span
                                className={`text-teal cursor-pointer`}
                                onClick={() => {
                                    updateRosterTabState({ ...rosterTabState, showCompareTeamPopUp: true });
                                }}
                                type={'college'}
                            >
                                {'Compare Teams'}
                            </span>
                            <span>{` \u2022 `}</span>
                            {isAdminOrOwner && (
                                <span
                                    className={`text-teal cursor-pointer`}
                                    onClick={() => {
                                        // Check if roster is locked for college rosters (only when ROSTERS_ROLLOUT is enabled)
                                        if (isRostersRolloutEnabled && tierType.isCollege && schoolDetails?.locked) {
                                            updateRosterTabState({ ...rosterTabState, showRosterLockedPopUp: true });
                                        } else if (tierType.isHighSchool) {
                                            history.push(`/clubs/${id}/add-members`);
                                        } else {
                                            updateRosterTabState({ ...rosterTabState, showAddPlayerToRosterPopUp: true });
                                        }
                                    }}
                                >
                                    {'Add a Player'}
                                </span>
                            )}
                            <span>{` \u2022 `}</span>
                            <span
                                className={`text-teal cursor-pointer`}
                                onClick={() => {
                                    const nextUrl = location.pathname;
                                    history.push({
                                        pathname: `/save-to-list/schools/${id}`,
                                        search: `?next=${nextUrl}`,
                                        state: {
                                            name: clubDetails.name,
                                        },
                                    });
                                }}
                            >
                                {'Save to List'}
                            </span>
                        </React.Fragment>
                    )}
                </span>
            </h6>
        </div>
    );
};
RosterTabTitleLayout.defaultProps = {
    clubDetails: {},
    power6Data: null,
    userIsPowered: false,
};
RosterTabTitleLayout.propTypes = {
    clubDetails: PropTypes.shape({
        tierType: PropTypes.object,
        id: PropTypes.number,
        clubSubType: PropTypes.object,
        name: PropTypes.string,
    }),
    schoolDetails: PropTypes.shape({
        rosterCount: PropTypes.number,
        rosterYear: PropTypes.number,
        power6: PropTypes.number,
        power6High: PropTypes.number,
        power6Low: PropTypes.number,
        power6Men: PropTypes.number,
        power6MenHigh: PropTypes.number,
        power6MenLow: PropTypes.number,
        power6Women: PropTypes.number,
        power6WomenHigh: PropTypes.number,
        power6WomenLow: PropTypes.number,
    }).isRequired,
    isAdminOrOwner: PropTypes.bool.isRequired,
    userIsPowered: PropTypes.bool,
    isSchool: PropTypes.bool.isRequired,
    rosterTabState: PropTypes.shape({
        showCompareTeamPopUp: PropTypes.bool,
        showAddPlayerToRosterPopUp: PropTypes.bool,
    }).isRequired,
    updateRosterTabState: PropTypes.func.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }).isRequired,
    power6Data: PropTypes.shape({
        power6Rating: PropTypes.number,
        power6HighRating: PropTypes.number,
        power6LowRating: PropTypes.number,
    }),
};
export default withRouter(RosterTabTitleLayout);
